














import { Component, Prop, VModel } from "vue-property-decorator";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import CommonService from "@/services/CommonService";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import SelectOption from "@/components/common/SelectOption";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import PRILExtension from "@/mixins/PRILExtension";

@Component<DictionarySelect>({
  components: { PortalSelect },
  inheritAttrs: false,
})
export default class DictionarySelect extends PRILExtension {
  @Prop({ default: null })
  private groupName!: string | null

  @Prop({ required: true })
  private name!: string;

  @VModel({ type: Number })
  private dictId!: number;

  private dictionaries: Array<PortalDictionaryDTO> = [];

  mounted(): void {
    if (this.groupName) {
      Application.startLoading();
      CommonService.findByGroupName(this.groupName)
        .then(
          res => {
            this.dictionaries = res.data;
            Application.stopLoading();
          },
          err => processError(err, this)
        );
    }
  }

  get buildDictionaries(): Array<SelectOption> {
    return this.dictionaries.map(dictionary => SelectOption.builder().title(this.getDictionaryTitle(dictionary)).value(dictionary.id).build())
  }
}
